import type { ObjectValues } from "@iyk/core"

export const InfluencerRoutes = {
  home: "/influencer",
  landing: "/influencer/landing",
  login: "/influencer/login",
  logout: "/influencer/logout",
  managePayouts: "/influencer/manage-payouts",
  oauthCallback: "/influencer/oauth-callback",
  onboarding: "/influencer/onboarding",
  resendOtp: "/influencer/resend-otp",
  settings: "/influencer/settings",
  verification: "/influencer/verification",
} as const

export type InfluencerRoute = ObjectValues<typeof InfluencerRoutes>
